import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React, { useContext } from 'react';
import { Link as Link$1 } from 'react-router-dom';
import { useAppSelector } from '../../../../hooks/hooks.js';
import { selectMode } from '../../../../store/reducers/enginePropertiesSlice.js';
import { classNames } from 'primereact/utils';
import { PagePathsContext } from '../../../../components/pagePathsContext.js';

function Link(_a) {
    var { linkProps, className } = _a, otherAnchorProps = __rest(_a, ["linkProps", "className"]);
    const pagePaths = useContext(PagePathsContext);
    const mode = useAppSelector(selectMode);
    if (!linkProps) {
        return null;
    }
    const { type, label, to, openIn } = linkProps;
    if (type === "internal") {
        const target = mode === "live" && pagePaths !== null ? pagePaths[to] : to;
        return (React.createElement(Link$1, Object.assign({}, otherAnchorProps, { to: target, className: classNames(className, {
                "pointer-events-none": mode === "design"
            }) }), label));
    }
    if (openIn === "newTab") {
        return (React.createElement("a", Object.assign({}, otherAnchorProps, { href: to, rel: "noopener noreferrer", target: "_blank", className: classNames(className, {
                "pointer-events-none": mode === "design"
            }) }), label));
    }
    if (openIn === "window") {
        return (React.createElement("a", Object.assign({}, otherAnchorProps, { href: "#", onClick: () => window.open(to, "_blank", "noopener,noreferrer,popup,width=600,height=600"), className: classNames(className, {
                "pointer-events-none": mode === "design"
            }) }), label));
    }
    return (React.createElement("a", Object.assign({}, otherAnchorProps, { href: to, className: classNames(className, {
            "pointer-events-none": mode === "design"
        }) }), label));
}

export { Link as default };
//# sourceMappingURL=index.js.map
